import React from 'react'

export const IncognitoSmallWithBackgroundSvg = ({ size = '24' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <rect width="24" height="24" fill="#2F3D4A" rx="12" />
      <path
        fill="#FFF"
        d="M11.186 17.021c-1.802-.15-2.395.254-2.395.254-.11.358-.4.925-.4.925-.927 0-1.309-.239-1.309-.239C5.283 10.526 8.227 5.107 8.227 5.107s.073-.127.227-.104c0 0 .246-.015.255.283 0 0 .082 2.474.378 3.085l.05.084s2.422-.851 5.72.022l.042-.08c.308-.563.392-3.11.392-3.11.01-.3.255-.284.255-.284a.229.229 0 0 1 .227.104s2.944 5.42 1.145 12.854c0 0-.382.239-1.309.239 0 0-.29-.567-.4-.925 0 0-.594-.405-2.407-.252l-.802.539-.814-.54z"
      />
      <g fill="#2F3D4A">
        <path d="M11.284 14.617s.444.154.315.393c0 0-1.205 1.128-2.429.786 0 0-1.353-.495-1.15-1.402 0 0 .131-.752.91-.564 0 0 1.538.436 2.205.727l.149.06zM12.739 14.617s-.445.154-.315.393c0 0 1.205 1.128 2.428.786 0 0 1.353-.495 1.15-1.402 0 0-.13-.752-.909-.564 0 0-1.539.436-2.206.727l-.148.06z" />
      </g>
    </g>
  </svg>
)
